import { toObject } from "../../core/utils";

class CaptainAppVersionPageTransform {
  constructor() {
    "ngInject";
  }

  justify(data) {
    const format = (item) => {
      item.description = item.description || {};

      return item;
    };

    return toObject(format(data));
  }
}

export default CaptainAppVersionPageTransform;



// WEBPACK FOOTER //
// ./src/pages/captainAppVersion/captainAppVersion.transforms.js